import React from "react"
import { graphql } from "gatsby"
import styled from "@emotion/styled"

import Layout from "../components/global/Layout"
import Seo from "../components/global/SEO"
import Nav from "../components/global/Nav"
import Footer from "../components/global/Footer"

import BackgroundImage from "../components/global/BackgroundImage"
import Button from "../components/global/Button"
import CountUp from "../components/blocks/CountUp"
import CenteredTextHero from "../components/blocks/CenteredTextHero"
import SplitFeature from "../components/blocks/SplitFeature"
import CountUpFigure from "../components/blocks/CountUpFigure"

const Counter = styled.div`
  position: relative;
  padding-top: 60px;
  h3 {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    text-align: center;
    font-weight: 600;
  }
`
const Label = styled.div`
  font-size: 1.2rem;
  text-align: center;
  max-width: 240px;
  margin: 16px auto 0;
  color: ${props => props.theme.shade[100]};
  p {
    margin: 0;
  }
`

const IndexPage = ({ data }) => (
  <Layout>
    <Seo title="Home" />
    <Nav />
    <BackgroundImage>
      <div>
        <div
          dangerouslySetInnerHTML={{
            __html: data.prismicHome.data.hero_text.html,
          }}
        ></div>
        <Button to="/team/">Meet our team</Button>
      </div>
    </BackgroundImage>
    <CountUp>
      {data.prismicHome.data.countup.map(counter => (
        <Counter>
          <CountUpFigure figure={counter.number} suffix={counter.suffix.text} />
          <Label>
            <div
              dangerouslySetInnerHTML={{
                __html: counter.label.html,
              }}
            ></div>
          </Label>
        </Counter>
      ))}
    </CountUp>
    <CenteredTextHero>
      <div
        dangerouslySetInnerHTML={{
          __html: data.prismicHome.data.callout.html,
        }}
      ></div>
    </CenteredTextHero>
    <SplitFeature
      left={
        <div
          dangerouslySetInnerHTML={{
            __html: data.prismicHome.data.particle_text_left.html,
          }}
        ></div>
      }
      right={
        <div
          dangerouslySetInnerHTML={{
            __html: data.prismicHome.data.particle_text_right.html,
          }}
        ></div>
      }
    />
    <Footer />
  </Layout>
)

export const pageQuery = graphql`
  query MyQuery {
    prismicHome {
      data {
        countup {
          number
          label {
            html
          }
          suffix {
            text
          }
        }
        callout {
          html
        }
        hero_text {
          html
        }
        particle_text_left {
          html
        }
        particle_text_right {
          html
        }
        title {
          text
        }
      }
    }
  }
`

export default IndexPage
